export default "/_next/static/dba6abd8aedfc28475d21f2eaba08f6c.png";